import { useSelector } from "react-redux";
import { Spin } from "antd";
import { selectLoadingPage } from "../store/app/app.slice";
import { t } from "@lingui/macro";
import React from "react";

interface Props {
	scope?: "local" | "global";
}

const Loading : React.FC<Props> = ({ scope = "global" }) => {
	const loadingPage = useSelector(selectLoadingPage);

	if(scope === "local") {
		return (
			<div className="flex h-screen">
				<Spin className="m-auto" size="large" />
			</div>
		);
	}

	return (
		<div
			className={`w-screen h-screen fixed z-[2000] flex justify-center items-center bg-slate-200/50 transition-all duration-300 ${
				loadingPage ? "visible opacity-100" : "invisible opacity-0 "
			}`}
		>
			<Spin tip={t`Loading` + "..."} size="large" />
		</div>
	);
};

export default Loading;
